import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ProviderService } from '../../../provider.service';
import { IProviderBase, PROVIDER_TTL_ES } from '../../../provider.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { MessageService } from 'primeng/api';
import { ClientService } from 'src/app/pages/gestion/clients/client.service';

@Component({
  selector: 'pg-provider-create',
  templateUrl: './provider-create.component.html',
  providers: [MessageService]
})
export class ProviderCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  loading: boolean = false;
  constructor(
    private fb: FormBuilder,
    private serviceBase: ProviderService,
    private messageService: MessageService,
    private clientService: ClientService
  ) {
    super(PROVIDER_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      ruc: [
        '',
        [
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.pattern('\\d+')
        ]
      ],
      name: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      address: ['', [Validators.minLength(5), Validators.maxLength(255)]],
      email: ['', [Validators.email]],
      mobile: [
        '',
        [
          Validators.minLength(9),
          Validators.maxLength(9),
          Validators.pattern('\\d+')
        ]
      ]
    });
  }

  onSubmit() {
    const provider = this.parseDate();
    this.createItem$(provider);
  }

  async onComplete() {
    const identity = this.fg.get('ruc').value;
    if (identity.length !== 11) {
      this.showErrorMessage('El RUC debe tener 11 dígitos');
      return;
    }
    this.loading = true;
    try {
      const response = await this.clientService.getFullName('ruc', identity);
      if (response.status !== 200) {
        this.fg.get('name').setValue('');
        this.showErrorMessage(response.message);
        return;
      }
      const data = response.data as any;
      this.fg.get('name').setValue(data.name);
    } catch (error) {
      this.fg.get('ruc').setValue('');
      this.showErrorMessage('Hubo un error al obtener el nombre');
    } finally {
      this.loading = false;
    }
  }

  private parseDate() {
    const provider = this.fg.value as IProviderBase;
    if (provider.address == null || provider.address == '')
      delete provider.address;
    if (provider.email == null || provider.email == '') delete provider.email;
    if (provider.mobile == null || provider.mobile == '')
      delete provider.mobile;
    return provider;
  }

  private showErrorMessage(message: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: message
    });
  }
}
